"use client";

import { createBrowserClient } from "@supabase/ssr";

/**
 * Supabase client voor gebruik in Client Components (browser).
 * Gebruikt de publieke anon key — RLS dwingt row-level toegang af.
 */
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );
}
